<template>
  <div>
    <div>
      <span class="text-overline" >
        {{ $t('indicators.measure_type') }}
      </span>
    </div>
  <v-input
    v-model="value"
    :rules="rules"
    :value="value"
  >
    <div class="mem-cont">
      <v-btn-toggle
        v-model="props.type"
        color="primary"
        group
      >
          <v-btn
            v-for="tdata in types"
            :key="tdata.key"
            :value="tdata.key"
            :disabled="props.readonly"
              class="qmkey-modal-dialog-button-secondary"
          >
            {{ tdata.name }}
          </v-btn>
        </v-btn-toggle>

        <MetricEditCategory
          v-if="props.type == 'category'"
          :value="props.value"
          @input="update_value"
        />
        <MetricEditNumber
          v-if="props.type == 'number'"
          :value="props.value"
          @input="update_value"
        />
        <MetricEditIndicator
          v-if="props.type == 'indicator'"
          :current_unit="props.current_unit"
          :value="props.value"
          @input="update_value"
        />
    </div>
  </v-input>
  </div>
</template>

<style lang="sass">
  
</style>

<script>
  import MetricEditCategory from '@/components/indicator/MetricEditCategory';
  import MetricEditNumber from '@/components/indicator/MetricEditNumber';
  import MetricEditIndicator from '@/components/indicator/MetricEditIndicator';
  import { TYPES_NAMES } from '@/utils/indicator.js';

  export default {
    name: 'InputMetricEdit',

    components: {
      MetricEditCategory,
      MetricEditNumber,
      MetricEditIndicator,
    },

    props: ['props'],

    data: () => ({
      variable_type: null,
    }),

    mounted() {
      if (this.props.value) {
        this.variable_type = this.props.type;
      }
      console.log(this);
    },

    computed: {
      allowed_types() {
        if (this.props.allowed_types === undefined || this.props.allowed_types === null) {
          return Array.from(Object.keys(TYPES_NAMES));
        }
        return this.props.allowed_types;
      },

      types() {
        return (Object
          .entries(TYPES_NAMES)
          .filter(([k, z]) => (this.allowed_types.indexOf(k) >= 0))
          .map(([k, v]) => ({key: k, name: v}))
        );
      },

      rules() {
        // TODO: Multilang: Change hardcoded string
        return [(value) => !!value || !this.props.required || this.$t('required_field')];
      },

      value() {
        return this.props.value;
      },
    },

    methods: {
      update_value(value) {
        this.props.value = {'type': this.props.type, 'value': value}
        this.update(this.props.value);
      },

      update(value) {
        this.$emit('update', value);
      },
    },

    watch: {
      value() {
        if(!this.props.value && this.props.type) {
          this.props.type = null;
        }
      },
    }
  }
</script>
